export default __webpack_public_path__ + "6b58dbb22757a41068e435acd02c2bbf.png";